import React, { useEffect } from 'react';
import { Routes, Route, useParams, useNavigate } from 'react-router-dom';
import * as routes from '../constants/routes';

import HomeContainer from '../containers/HomeContainer';
import NotFound from '../components/NotFound';
import ForgetPasswordContainer from '../containers/ForgetPasswordContainer';
import SignOutContainer from '../containers/SignOutContainer';
import AuthRoute from './AuthRoute';
import AnyRoute from './AnyRoute';
import PrivateRoute from './PrivateRoute'
import LandingPageContainer from '../containers/LandingPageContainer';
import TermsContainer from '../containers/TermsContainer';
import PrivacyContainer from '../containers/PrivacyContainer';
import AppContainer from '../containers/AppContainer';
import i18n from '../i18n';
import Affiliate from '../components/Affiliate';
import YearbookPageContainer from '../containers/YearbookPageContainer';
import XContainer from '../containers/XContainer';
import AdsLandingPageContainer from '../containers/AdsLandingPageContainer';
import AdsRoute from './AdsRoute';
import RefundPolicy from '../components/RefundPolicy';
import VerifyEmailContainer from '../containers/VerifyEmailContainer';
import SignUpEmailAndGoogle from '../containers/SignUpEmailAndGoogleContainer';

const LanguageRoute = () => {
  const { lang } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (lang === 'lemonsqueezy') {
      setTimeout(() => {
        const mainLang = localStorage.getItem('mainLang');
        if (mainLang !== null) {
          navigate(`/${mainLang}/app`);
        } else {
          navigate(`/app`);
        }
      }, 2000);
    }
    else if (['en', 'vi', 'id', 'jp', 'ko', 'zh'].includes(lang)) {
      i18n.changeLanguage(lang);

      const languageMetaTags = {
        en: {
          title: 'Decorify: AI Virtual Staging, Remodeling & Interior Design',
          description: 'Decorify is an AI-powered app for Virtual Staging, Remodeling, Landscaping, Interior, Exterior Designing, and beyond.',
          meta: 'images/meta_decorify.webp'
        },
        vi: {
          title: 'Decorify: Dàn dựng ảo AI, Cải tạo & Thiết kế nội thất, ngoại thất',
          description: 'Decorify là một ứng dụng được hỗ trợ bởi AI cho Dàn dựng ảo, Cải tạo, Cảnh quan, Thiết kế Nội thất, Ngoại thất và hơn thế nữa.',
          meta: 'images/meta_decorify.webp'
        },
        zh: {
          title: 'Decorify: AI虚拟布景、翻新和室内设计',
          description: 'Decorify是一款由AI驱动的应用程序，用于虚拟布景、翻新、景观美化、室内和室外设计等。',
          meta: 'images/meta_decorify.webp'
        },
        id: {
          title: 'Decorify: Penataan Virtual AI, Renovasi & Desain Interior',
          description: 'Decorify adalah aplikasi bertenaga AI untuk Penataan Virtual, Renovasi, Lanskap, Desain Interior, Eksterior, dan lainnya.',
          meta: 'images/meta_decorify.webp'
        },
        jp: {
          title: 'Decorify: AIバーチャルステージング、リモデリング、インテリアデザイン',
          description: 'Decorifyは、バーチャルステージング、リモデリング、ランドスケーピング、インテリア、エクステリアデザインなどのためのAI駆動アプリです。',
          meta: 'images/meta_decorify.webp'
        },
        ko: {
          title: 'Decorify: AI 가상 스테이징, 리모델링 및 인테리어 디자인',
          description: 'Decorify는 가상 스테이징, 리모델링, 조경, 인테리어, 외관 디자인 등을 위한 AI 기반 앱입니다.',
          meta: 'images/meta_decorify.webp'
        },
        // Add titles and descriptions for other languages as needed
      };

      const { title, description, meta } = languageMetaTags[lang];
      document.title = title;

      // Update Open Graph (og) meta tags
      const ogTitle = document.querySelector('meta[property="og:title"]');
      if (ogTitle) {
        ogTitle.setAttribute('content', title);
      }

      const ogDescription = document.querySelector('meta[property="og:description"]');
      if (ogDescription) {
        ogDescription.setAttribute('content', description);
      }

      const metaUrl = document.querySelector('meta[property="og:image"]');
      if (metaUrl) {
        metaUrl.setAttribute('content', meta);
      }

      const twitterTitle = document.querySelector('meta[name="twitter:title"]');
      if (twitterTitle) {
        twitterTitle.setAttribute('content', title);
      }

      const twitterDescription = document.querySelector('meta[name="twitter:description"]');
      if (twitterDescription) {
        twitterDescription.setAttribute('content', description);
      }

      const twitterUrl = document.querySelector('meta[name="twitter:image"]');
      if (twitterUrl) {
        twitterUrl.setAttribute('content', meta);
      }
    }
  }, [lang, navigate]);

  return (
    <>
      <Routes>
        <Route
          path="/"
          element={<AnyRoute />}
        >
          <Route
            path={routes.LANDING}
            element={<LandingPageContainer />}
          >
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route
            path={routes.TERMS_CONDITIONS}
            element={<TermsContainer />}
          >
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route
            path={routes.PRIVACY}
            element={<PrivacyContainer />}
          >
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route
            path={routes.REFUND}
            element={<RefundPolicy />}
          >
            <Route path="*" element={<NotFound />} />
          </Route>
          {/* <Route
          path={routes.YEARBOOK}
          element={<YearbookPageContainer />}
        >
          <Route path="*" element={<NotFound />} />
        </Route> */}
        </Route>
        <Route
          path="/"
          element={<PrivateRoute />}
        >
          <Route
            path={routes.HOME}
            element={<HomeContainer />}
          >
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route
            path={routes.APP}
            element={<AppContainer />}
          >
            <Route path="*" element={<NotFound />} />
          </Route>
        </Route>
        <Route
          path="/"
          element={<AuthRoute />}
        >
          <Route
            path={routes.SIGN_IN}
            element={<SignUpEmailAndGoogle />}
          >
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route
            path={routes.SIGN_UP}
            element={<SignUpEmailAndGoogle />}
          >
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route
            path={routes.SIGN_OUT}
            element={<SignOutContainer />}
          >
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route
            path={routes.FORGET_PASSWORD}
            element={<ForgetPasswordContainer />}
          >
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route
            path={routes.VERIFY_EMAIL}
            element={<VerifyEmailContainer />}
          >
            <Route path="*" element={<NotFound />} />
          </Route>
        </Route>
        {/* <Route
          path="/"
          element={<AdsRoute />}
        >
          <Route
            path={routes.AIHEADSHOT}
            element={<AdsLandingPageContainer />}
          >
            <Route path="*" element={<NotFound />} />
          </Route>
        </Route> */}
      </Routes>
    </>
  );
};

const AppRoutes = () => {
  return (
    <Routes>
      <Route
        path="/:lang/*"
        element={<LanguageRoute />}
      />
      <Route
        path="/"
        element={<AnyRoute />}
      >
        <Route
          path={routes.LANDING}
          element={<LandingPageContainer />}
        >
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route
          path={routes.X}
          element={<XContainer />}
        >
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route
          path={routes.AFFILIATE}
          element={<Affiliate />}
        >
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route
          path={routes.TERMS_CONDITIONS}
          element={<TermsContainer />}
        >
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route
          path={routes.PRIVACY}
          element={<PrivacyContainer />}
        >
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route
          path={routes.REFUND}
          element={<RefundPolicy />}
        >
          <Route path="*" element={<NotFound />} />
        </Route>
        {/* <Route
          path={routes.YEARBOOK}
          element={<YearbookPageContainer />}
        >
          <Route path="*" element={<NotFound />} />
        </Route> */}
      </Route>
      <Route
        path="/"
        element={<PrivateRoute />}
      >
        <Route
          path={routes.HOME}
          element={<HomeContainer />}
        >
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route
          path={routes.APP}
          element={<AppContainer />}
        >
          <Route path="*" element={<NotFound />} />
        </Route>
      </Route>
      <Route
        path="/"
        element={<AuthRoute />}
      >
        <Route
          path={routes.SIGN_IN}
          element={<SignUpEmailAndGoogle />}
        >
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route
          path={routes.SIGN_UP}
          element={<SignUpEmailAndGoogle />}
          >
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route
          path={routes.SIGN_OUT}
          element={<SignOutContainer />}
        >
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route
          path={routes.FORGET_PASSWORD}
          element={<ForgetPasswordContainer />}
        >
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route
          path={routes.VERIFY_EMAIL}
          element={<VerifyEmailContainer />}
        >
          <Route path="*" element={<NotFound />} />
        </Route>
      </Route>
      {/* <Route
        path="/"
        element={<AdsRoute />}
      >
        <Route
          path={routes.AIHEADSHOT}
          element={<AdsLandingPageContainer />}
        >
          <Route path="*" element={<NotFound />} />
        </Route>
      </Route> */}
    </Routes>
  );
};

export default AppRoutes;
